interface PhaseBadgeProps {
  name: string
  color: string
}

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function PhaseBadge({ name, color }: PhaseBadgeProps) {
  return (
    <span
      className="shrink-0 inline-flex items-center h-6 px-2.5 rounded-full border text-xs font-medium"
      style={{ borderColor: color, color, backgroundColor: hexToRgba(color, 0.24) }}
      data-testid="prompt-phase-badge"
    >
      {name}
    </span>
  )
}
